import objectPrefix from '../../lib/objectPrefix';

const prefix = objectPrefix();

module.exports = {
    magnifierGirl1: {
        type: 'movieclip',
        scale: {
            y: '90%',
        },
        position: {
            x: '-15%',
            y: '-2%',
        },
        /* texture: [
            '/img/partials/bucket-analyser/magnifier-girl/1/magnifier-girl-0.png',
            '/img/partials/bucket-analyser/magnifier-girl/1/magnifier-girl-1.png',
            '/img/partials/bucket-analyser/magnifier-girl/1/magnifier-girl-2.png',
            '/img/partials/bucket-analyser/magnifier-girl/1/magnifier-girl-3.png',
            '/img/partials/bucket-analyser/magnifier-girl/1/magnifier-girl-4.png',
            '/img/partials/bucket-analyser/magnifier-girl/1/magnifier-girl-5.png',
            '/img/partials/bucket-analyser/magnifier-girl/1/magnifier-girl-6.png'
        ]*/
        texture: `sprite:/img/partials/bucket-analyser/magnifier-girl-${prefix}.json,magnifier-girl/1`,
    },

    magnifierGirl2: {
        type: 'movieclip',
        scale: {
            y: '90%',
        },
        position: {
            x: '-15%',
            y: '-2%',
        },
        /* texture: [
            '/img/partials/bucket-analyser/magnifier-girl/2/magnifier-girl-0.png',
            '/img/partials/bucket-analyser/magnifier-girl/2/magnifier-girl-1.png',
            '/img/partials/bucket-analyser/magnifier-girl/2/magnifier-girl-2.png',
            '/img/partials/bucket-analyser/magnifier-girl/2/magnifier-girl-3.png',
            '/img/partials/bucket-analyser/magnifier-girl/2/magnifier-girl-4.png',
            '/img/partials/bucket-analyser/magnifier-girl/2/magnifier-girl-5.png',
            '/img/partials/bucket-analyser/magnifier-girl/2/magnifier-girl-6.png',
            '/img/partials/bucket-analyser/magnifier-girl/2/magnifier-girl-7.png',
            '/img/partials/bucket-analyser/magnifier-girl/2/magnifier-girl-8.png',
            '/img/partials/bucket-analyser/magnifier-girl/2/magnifier-girl-9.png',
            '/img/partials/bucket-analyser/magnifier-girl/2/magnifier-girl-10.png',
            '/img/partials/bucket-analyser/magnifier-girl/2/magnifier-girl-11.png'
        ]*/
        texture: `sprite:/img/partials/bucket-analyser/magnifier-girl-${prefix}.json,magnifier-girl/2`,
    },

    magnifierGirl3: {
        type: 'movieclip',
        scale: {
            y: '90%',
        },
        position: {
            x: '-15%',
            y: '-2%',
        },
        /* texture: [
            '/img/partials/bucket-analyser/magnifier-girl/3/magnifier-girl-0.png',
            '/img/partials/bucket-analyser/magnifier-girl/3/magnifier-girl-1.png',
            '/img/partials/bucket-analyser/magnifier-girl/3/magnifier-girl-2.png',
            '/img/partials/bucket-analyser/magnifier-girl/3/magnifier-girl-3.png'
        ] */
        texture: `sprite:/img/partials/bucket-analyser/magnifier-girl-${prefix}.json,magnifier-girl/3`,
    },
};



// WEBPACK FOOTER //
// ./js/objects/partials/magnifierGirl.js